import React from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    //width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const CustomToast = ({
  open,
  handleCloseCustomToast,
  title,
  success = false,
  error = false,
  warning = false,
  info = false,
  closeAutoHide,
  backToHome = false,
}) => {
  const classes = useStyles();
  const [vertical] = React.useState("bottom");
  const [horizontal] = React.useState("right");
  const history = useHistory(); // Get the history instance

  const handleExited = () => {
    if(backToHome){
      history.push("/")
    }
  };

  return (
    <div className={classes.root}>
      <Snackbar
        open={open}
        autoHideDuration={closeAutoHide ? null : 6000}
        onClose={handleCloseCustomToast}
        onExit={handleExited}
        anchorOrigin={{ vertical, horizontal }}
      >
        {success ? (
          <Alert onClose={handleCloseCustomToast} severity="success">
            {title}
          </Alert>
        ) : error ? (
          <Alert onClose={handleCloseCustomToast} severity="error">
            {title}
          </Alert>
        ) : warning ? (
          <Alert onClose={handleCloseCustomToast} severity="warning">
            {title}
          </Alert>
        ) : info ? (
          <Alert onClose={handleCloseCustomToast} severity="info">
            {title}
          </Alert>
        ) : (
          false
        )}
      </Snackbar>
    </div>
  );
};

export default CustomToast;
